import { gunzipSync, gzipSync } from 'zlib';
const SYMON_COMPRESSED_NAME = `SYMON_COMPRESSED_ENVS`;
export class SymonEnvsCache {
    static getWithDefault(key, defaultValue) {
        const value = process.env[key];
        if (value !== undefined) {
            return value;
        }
        if (!this.init) {
            this.initCache();
        }
        return this.cache.get(key) ?? defaultValue;
    }
    static get(key) {
        const value = process.env[key];
        if (value !== undefined) {
            return value;
        }
        if (!this.init) {
            this.initCache();
        }
        if (this.cache.has(key)) {
            return this.cache.get(key);
        }
        throw new Error(`${key} environment variable not set.`);
    }
    static initCache() {
        const symonCompressedEnvs = process.env[SYMON_COMPRESSED_NAME];
        if (symonCompressedEnvs !== undefined) {
            const compressedBuffer = Buffer.from(symonCompressedEnvs, 'base64');
            const jsonString = gunzipSync(compressedBuffer).toString();
            const json = JSON.parse(jsonString);
            for (const [key, value] of Object.entries(json)) {
                this.cache.set(key, String(value));
            }
        }
        this.init = true;
    }
    static compressEnvs(envs) {
        return gzipSync(JSON.stringify(envs)).toString('base64');
    }
    static processEnvToJson() {
        const json = {};
        for (let key in process.env) {
            if (process.env.hasOwnProperty(key)) {
                json[key] = process.env[key];
            }
        }
        return json;
    }
}
SymonEnvsCache.cache = new Map();
SymonEnvsCache.init = false;
//# sourceMappingURL=symonEnvsCache.js.map